export type LegoColor =
  | 'yellow'
  | 'red'
  | 'blue'
  | 'white'
  | 'black'
  | 'orange'
  | 'purple'
  | 'green';
export type LegoSize = 'S' | 'M' | 'L';

export type BaseplateSize = '16x32' | '32x32';

export const BASEPLATE_SIZES: Record<BaseplateSize, { baseWidth: number; baseHeight: number }> = {
  // 16×32 en horizontal: 32 studs d'ample × 16 d'alt
  '16x32': { baseWidth: 32, baseHeight: 16 },
  '32x32': { baseWidth: 32, baseHeight: 32 },
};

// Mides reals en studs (1 stud = 8mm)
export const REAL_SIZES = {
  S: {
    letterWidth: 5, // Amplada del patró en studs (5x5)
    letterHeight: 5,
  },
  M: {
    letterWidth: 10, // 5 studs × escala 2
    letterHeight: 10,
  },
  L: {
    letterWidth: 15, // 5 studs × escala 3
    letterHeight: 15,
  },
} as const;

export interface PixelPosition {
  x: number;
  y: number;
}

export interface LegoPattern {
  pixels: boolean[][]; // Matriu base (4x6)
  color: LegoColor;
}

export type BrickInventory = { [key: string]: number };
